import { render, staticRenderFns } from "./FrameTypeSelect.vue?vue&type=template&id=9c998972&"
import script from "./FrameTypeSelect.vue?vue&type=script&lang=js&"
export * from "./FrameTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./FrameTypeSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TechOption: require('/opt/build/repo/storefront/components/atoms/TechSelect/TechOption.vue').default})
